import { render } from "./PostJobView.vue?vue&type=template&id=b910c70c"
import script from "./PostJobView.vue?vue&type=script&lang=js"
export * from "./PostJobView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__